export default "/images/08985327416cbed811d006e336e0412d.avif";